var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1549 30L3.84494 30C1.73237 30 0 28.2677 0 26.1549L0 3.84513C0 1.73212 1.73237 0 3.84494 0L26.1549 0C28.2674 0 30 1.73212 30 3.84506L30 26.1549C30 28.2677 28.2674 30 26.1549 30ZM6.64506 11.5L9.71525 16.5636L7.41231 20.625H11.3095L13.6109 16.5636L10.5409 11.5H6.64506ZM21.1705 6.125H17.0364L13.0798 13.0835L19.2196 23.875H23.3534L17.2127 13.0835L21.1705 6.125Z",
    fill: "#D8D7CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXing);
export default __webpack_public_path__ + "static/media/xing.f556bc54d4a8fa0fbfb2815fb8cc842b.svg";
export { ForwardRef as ReactComponent };